import React, { FC } from 'react'
import { ArticleAuthorContentProps, TagProps } from '@sport1/types/web'
import AuthorArea from '@sport1/news-styleguide/AuthorArea'
import { transformImageUrlToSize } from '@/helpers/imageHelper'
import nofollowExternal from '@/utils/url/nofollowExternal'
import { getAuthorPageHref } from '@/utils/navigation/Navigator'
import { getPublishedDate } from '@/helpers/dateHelper'

type Props = {
    content: ArticleAuthorContentProps
}

const ArticleAuthors: FC<Props> = ({ content }) => (
    <AuthorArea
        authors={content.authors.map(author => ({
            ...author,
            imageUrl: author.imageUrl ? transformImageUrlToSize(author.imageUrl, 40, 40) : '',
            createHref: author.activeStatus
                ? () => getAuthorPageHref({ title: author.name } as TagProps, author.id)
                : undefined,
        }))}
        published={getPublishedDate(content.publishedAt)}
        dateTime={content.publishedAt}
        webRel={nofollowExternal}
        marginBottom={['spacing-9', 'spacing-9', 'spacing-11']}
    />
)

export default ArticleAuthors
